import { Component , HostBinding, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputValidationService } from '../helpers/validators/input-validation.service';
import { CommunicationService } from '../services/communication.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NumericFieldDirective } from '../helpers/directive/numeric-field.directive';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-callme-back',
    templateUrl: './callmeback.component.html',
    styleUrls: ['./callmeback.component.css'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, NgIf, TrackingDirective, NumericFieldDirective]
})
export class CallMeBackComponent implements OnInit {

  @HostBinding('style.width') public readonly WIDTH = '100%';

  title = 'webapp';
  callbackForm: FormGroup;
  idNumberAndErrorMsg: any = {};
  errorMsg = '';
  successMsg = '';
  successMsgAny: any = {};

  constructor(
    private formBuilder: FormBuilder,
    private communicationService: CommunicationService,
  ) { }

  ngOnInit() {
    this.callbackForm = this.formBuilder.group({
      FullName: ['', [Validators.required]],
      PhoneNumber: ['', [Validators.required, Validators.minLength(10), InputValidationService.isValidMobile]],
    });
  }

  get callbackFormControls() { return this.callbackForm.controls; }

  callback() {
    this.errorMsg = '';
    this.successMsg = '';
    if (this.callbackForm.invalid) {
      this.callbackForm.markAllAsTouched();
      return;
    }
  }
}
